'use strict';

import React from 'react';

import { OnSchedUtils } from '../../../utils';

import AvailableTime    from './AvailableTime/AvailableTime'
import NoAvailableTimes from './NoAvailableTimes/NoAvailableTimes'

const AvailableTimes = ({ availability, element, bookAppointment, deselect, deselected, date }) => {
  const [morning, setMorningTimes] = React.useState([]);
  const [afternoon, setAfternoonTimes] = React.useState([]);
  const [evening, setEveningTimes] = React.useState([]);

  React.useEffect(() => {
    if (availability) { 
      if (availability.availableTimes) {
        const times = availability.availableTimes.filter(d => d.date === date);

        setMorningTimes(times.filter(t => t.time < 1200));
        setAfternoonTimes(times.filter(t => t.time >= 1200 && t.time < 1800));
        setEveningTimes(times.filter(t => t.time >= 1800));
      }
    } 
  }, [availability]);

  const displayIfAvailable = (times, timeOfDay) => {
    return (
      times.length ? 
        <>
          <li className='onsched-dark-color time-of-day'>{OnSchedUtils.Internationalize(element, `consumer_availability_time_of_day_${timeOfDay}`)}</li>
          { times.map((time, i) => 
            <AvailableTime 
              key={i} 
              time={time} 
              element={element} 
              bookAppointment={bookAppointment} 
              deselect={deselect} 
              deselected={deselected} 
            />) }
        </>
        :
        null
    )
  }

  const noAvailableTimes = () => {
    if (!morning.length && !afternoon.length && !evening.length) {
      return true;
    }
    else return false;
  }

  return (
    <ul 
      className={`AvailableTimes ${element.options.calendarType === 'week' ? 'WeekView' : ''}`}
    >
      { displayIfAvailable(morning, 'morning') }
      
      { displayIfAvailable(afternoon, 'afternoon') }
      
      { displayIfAvailable(evening, 'evening') }

      { noAvailableTimes() ? <NoAvailableTimes element={element} /> : null }
    </ul>
  )
}

export default AvailableTimes;
